export const callIfScrollToBottom = action => {
  if (!action) return undefined
  return ({ target }) => {
    const isBottom = target.scrollHeight - target.scrollTop - 35 <= target.clientHeight
    if (!!isBottom) action()
  }
}
